module.exports = __webpack_public_path__ + "img/制御工学6_2.1e8392ca.png";